import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";

import "./table.css"
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ADMIN_TOOLS_DIVISION_DETAILS } from "../../routes";
import { Confirmation } from "../../components/dialog/confirmation";

const initialDataState = {
  skip: 0,
  take: 10,
  dir: "asc",
};
const initialSort = [
  {
    field: "name",
    dir: "desc",
  },
];

const itemRender = (li, itemProps) => {
  const index = itemProps.index;
  const itemChildren = (
    <span
      style={{
        display: "flex",
      }}
    >
      {li.props.children}
    </span>
  );
  return React.cloneElement(li, li.props, itemChildren);
}

const valueRender = (element, value) => {
  if (!value) {
    return element;
  }
  const children = [
    <span>&nbsp;&nbsp;&nbsp;&nbsp; {element.props.children}</span>,
  ];
  return React.cloneElement(
    element,
    {
      ...element.props,
    },
    children
  );
};

export const DivisionTableBody = (props) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(initialDataState);
  const [pageSizeValue, setPageSizeValue] = useState();
  const [sort, setSort] = useState(initialSort);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedID,setSelectedID] = useState(null);

  const pageChange = event => {
    const targetEvent = event.targetEvent;
    const take = targetEvent.value === 'All' ? props.data.length : event.page.take;
    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take
    });
  };
  
  const onItemActionChange = (e, val) => {
    const selected = e.target.value;
    const { id } = val
    if(selected === "View Details"){
      navigate(`${ADMIN_TOOLS_DIVISION_DETAILS}?id=${id}`);
    }else{
      setSelectedID(val.id);      
      setShowConfirm(true);
    }
  }
  const handleConfirmDelete = (()=>{
    setShowConfirm(false);
    props.handleDeleteAction(selectedID);
  })
  return (
    <div className="tbody-content">
      {showConfirm && (
        <Confirmation 
          onClickYes={handleConfirmDelete}
          onClickNo={()=>setShowConfirm(false)}        
        />
      )}
      <Grid
        data={orderBy(props.data.slice(page.skip, page.take + page.skip),sort)}
        skip={page.skip}
        take={page.take}
        total={props.data.length}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
        pageable={{
          buttonCount: 4,
          pageSizes: [5, 10, 15, 25, 35, 45, 55, 65, 75, 85, 100],
          pageSizeValue: pageSizeValue,
          info: true,
        }}
        pageSize={false}
        info={false}
        pageSizes={false}
        onPageChange={pageChange}
      >
        <GridColumn field="name" title="Division" />
        <GridColumn field="code" title="Code" width={330} />
        <GridColumn field="created_by.name" title="Created By" width={200}/>
        <GridColumn field="created_on" title="Created On"/>
        <GridColumn field="updated_by.name" title="Updated By" />
        <GridColumn field="updated_on" title="Updated On" />
        
        <GridColumn width={130} sortable={false}
          field="Action"
          cell={(props) => (
            <td className="k-table-td">
              <DropDownList
                size={"large"}
                fillMode={"solid"}
                rounded={"large"}
                className="action-btn-dropdown"
                data={["View Details", "Delete"]}
                valueRender={valueRender}
                itemRender={itemRender}
                defaultValue={"Action"}
                onChange={(e) => onItemActionChange(e, props.dataItem)}
                style={{
                  fontSize: "15px",
                }}
              />
            </td>
          )}
        />
      </Grid>
    </div>
  );
};